<template>
  <BasicModal
    :title="title"
    :isShowModal="isShowModal"
    :canCancel="true"
    @cancel="cancel">
    <div class="card-content parent-box">
      <div class="box-request">
        <p style="text-align: left; padding: 15px;" v-if="!authType">
          Cybozu Garoonとのスケジュール同期を行うことが可能です。<br/>
          ※ クライアントID / サブドメイン / シークレットID については、<br/>
          <span style="margin-left: 14px;"></span>システム担当者にお伺いください。
        </p>
        <p style="text-align: left; padding: 15px;" v-if="authType === 'garoon'">
          Cybozu GaroonのログインIDを再設定することができます。<br/>
        </p>
        <div style="text-align: left; padding: 15px;" v-if="!authType">
          クライアントID：
          <input class="input" style="width: 250px; height: 24px; color: #222; font-size: 16px;" placeholder="ID" v-model="user.cybozu_id"/>
        </div>
        <div style="text-align: left; padding: 15px;" v-if="!authType">
          サブドメイン名：https://
          <input class="input" style="width: 250px; height: 24px; color: #222; font-size: 16px;" placeholder="subdomain" v-model="user.cybozu_subdomain"/>.cybozu.com
        </div>
        <div style="text-align: left; padding: 15px;" v-if="!authType">
          シークレットID：
          <input class="input" style="width: 250px; height: 24px; color: #222; font-size: 16px;" placeholder="secret" v-model="user.cybozu_secret"/>
        </div>
        <div style="text-align: left; padding: 15px;">
          ログインID：
          <input class="input" style="width: 250px; height: 24px; color: #222; font-size: 16px;" placeholder="GaroonのログインID" v-model="user.cybozu_login_id"/>
        </div>
      </div>
    </div>
    <!-- フッターアクション -->
    <div class="footer-box">
      <button class="button" @click="cancel">キャンセル</button>
      <a @click="$emit('saveGaroonInit')" class="button is-primary" :href="'https://' + user.cybozu_subdomain + '.cybozu.com/oauth2/authorization?client_id=' + user.cybozu_id + '&redirect_uri=' + getURLAPI() + '/api/user/redirect/cybozu/&state=state1&response_type=code&scope=g%3aschedule%3aread%20g:base:read%20g:schedule:write'" :disabled="!user.cybozu_id||!user.cybozu_subdomain||!user.cybozu_secret||!user.cybozu_login_id" v-if="!authType">
        保有アカウントと連携する
      </a>
      <button @click="$emit('saveGaroon')" class="button is-primary" :disabled="!user.cybozu_login_id" v-if="authType === 'garoon'">
        設定を保存する
      </button>
      <button class="button is-danger" v-if="authType === 'garoon'" @click="clickDeleteGaroon">連携解除</button>
    </div>
  </BasicModal>
</template>

<script>
import BasicModal from '@/components/Modals/BasicModal'
export default {
  name: 'ModalGaroon',
  componentName: 'ModalGaroon',
  components: {
    BasicModal
  },
  props: {
    isShowModal: {
      type: Boolean,
      require: true
    },
    authType: {
      type: String,
      require: true
    },
    user: {
      type: Object,
      require: true
    }
  },
  data () {
    return {
      title: 'Garoon 連携'
    }
  },
  methods: {
    cancel () {
      this.$emit('cancel', false)
    },
    getURLAPI () {
      if (process.env.NODE_ENV === 'development') {
        return 'https://localhost:8000'
      } else if (process.env.NODE_ENV === 'staging') {
        return 'https://w2.ndr-staging.work'
      } else if (process.env.NODE_ENV === 'third') {
        return 'https://robottte.hr-monster.io'
      } else {
        return 'https://hr-monster.io'
      }
    },
    clickDeleteGaroon () {
      this.$emit('delete-garoon')
    }
  }
}
</script>

<style lang="scss" scoped>
.card-body {
  padding: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  overflow: auto;
}
.setting-card {
  height: 100px;
  width: 280px;
  border-radius: 8px;
  border: solid thin #ccc;
  margin: 8px 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  h2 {
    font-weight: 600;
    color: #C82E42;
    margin-bottom: 8px;
  }
  .input-box {
    padding: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    p {
      margin-left: 8px;
    }
    select {
      max-width: 200px;
    }
  }
}
.action-box {
  width: calc(100% - 32px);
  height: 48px;
  display: flex;
  align-items: center;
  margin-left: 16px;
  p {
    margin-left: 16px;
  }
}
.footer-box {
  width: 100%;
  height: 64px;
  border-top: solid thin #ccc;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  overflow: auto;
  button {
    width: 30%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Calendar/organisms/ModalGaroon.vue